const actionCreator = (action, payload) => {
  return {type: action, payload}
}

export default actionCreator;
